import { render, staticRenderFns } from "./Banks.vue?vue&type=template&id=1041c95a"
import script from "./Banks.vue?vue&type=script&lang=js"
export * from "./Banks.vue?vue&type=script&lang=js"
import style0 from "./Banks.vue?vue&type=style&index=0&id=1041c95a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports